<div class="document-block mt-2">
    <!-- Name And Contact -->
    <div class="formSection">
        <div class="head">
            <strong>Name and Contact </strong>
        </div>

        <div class="row m-2">
            <div class="col-md-6" style="text-align: left;">
                <div><span class="client-details-field">Name:</span>
                    <span class="client-details-value"> {{ currentClientData?.nameInitial?.name + ". " +
                        currentClientData?.firstName + " " + currentClientData?.lastName}}</span>
                </div>
                <div><span class="client-details-field">Father/Husband's Name:</span>
                    <span class="client-details-value">{{ ((currentClientData?.relationInitial?.name)?
                        (currentClientData?.relationInitial?.name) : "") + " " +
                        ((currentClientData?.fatherHusbandName)?
                        (currentClientData?.fatherHusbandName) : "")}}</span>
                </div>
                <div><span class="client-details-field">Contact Number:</span>
                    <span class="client-details-value">
                        {{commonService.formatPhoneNumberWithHyphen(currentClientData?.primaryPhoneNo)}}</span>
                </div>
                <div><span class="client-details-field">Altername Contact Number: </span>
                    <span class="client-details-value">{{
                        commonService.formatPhoneNumberWithHyphen(currentClientData?.secondaryPhoneNo)}}</span>
                </div>
                <div><span class="client-details-field">Date of Birth: </span>
                    <span class="client-details-value">{{ currentClientData?.dateOfBirth | date: 'yyyy-MM-dd'}}</span>
                </div>
                <div><span class="client-details-field">Email: </span>
                    <span class="client-details-value">{{ currentClientData?.email || '' }}</span>
                </div>
                <div><span class="client-details-field">Address: </span>
                    <span class="client-details-value">{{
                        ((currentClientData?.addresses[0]?.address1)?(currentClientData?.addresses[0]?.address1):'') +
                        ((currentClientData?.addresses[0]?.village?.name) ? ("," + " " +
                        currentClientData?.addresses[0]?.village?.name ) :'' )+
                        ((currentClientData?.addresses[0]?.village?.tehsil?.name) ? ("," + " " +
                        currentClientData?.addresses[0]?.village?.tehsil?.name ) :'' )+

                        ((currentClientData?.addresses[0]?.village?.tehsil?.district?.name)? ("," + " "
                        +currentClientData?.addresses[0]?.village?.tehsil?.district?.name):'') +
                        ((currentClientData?.addresses[0]?.village?.tehsil?.district?.state?.name) ? ("," + " " +
                        currentClientData?.addresses[0]?.village?.tehsil?.district?.state?.name) : '')
                        }}</span>
                </div>
            </div>
            <div class="col-md-6">
                <!-- <span class="client-details-field">Client Pic : </span> -->
                <!-- <div style="text-align: center;" class="avatar-preview">
                    <a class="lead-info">
                        <img src="{{ userProfileImage }}" width="100" height="100">
                    </a>
                </div> -->
                <br />
                <app-user-profile-pic [userData]="userProfileImageConfig"></app-user-profile-pic>
            </div>
        </div>
    </div>

    <!-- Identity -->
    <div class="formSection">
        <div class="head">
            <strong>Identity</strong>
        </div>
        <div class="row m-2">
            <div class="col-md-6" style="text-align: left;">
                <div><span class="client-details-field">Aadhar Number: </span>
                    <span
                        class="client-details-value">{{commonService.maskAadhaarNumber(currentClientData?.aadharNumber)}}</span>
                </div>
                <div><span class="client-details-field">PAN Number: </span>
                    <span class="client-details-value">{{ currentClientData?.panCardNo}}</span>
                </div>
            </div>
            <div class="col-md-6">
                <strong class="text-center">Bio Metric : </strong><br />
                <img [src]="currentClientData?.signatureImage" style="max-height: 60px;" />
            </div>
        </div>
    </div>

    <!-- Land Khata -->
    <div class="formSection" *ngIf="groupedKhasras?.length > 0">
        <div class="head">
            <strong>Land Khata Info</strong>
        </div>
        <ng-container *ngFor="let khata of groupedKhasras">
            <div class="khata-section">
                <div class="row m-2 align-items-center justify-content-between">
                    <div class="col-md-4"><strong>Khata Number: </strong> {{ khata?.landKhata?.name }}</div>
                    <div class="col-md-4"><strong>Total Khasra:</strong> {{ khata?.khasra?.length }}</div>
                    <div class="col-md-4"><strong>Total Area:</strong> {{ khata?.totalArea }} Biswa</div>
                </div>
                <table>
                    <th>Khasra #</th>
                    <th>Area (Biswa)</th>
                    <th>Payment (Farmer)</th>
                    <th>Payment (Khasra)</th>
                    <tr *ngFor="let individualKhasra of khata.khasra">
                        <td>
                            <span class="modal-hyperlink-text" (click)="openKhasraModal(individualKhasra)">
                                {{ individualKhasra?.name }}
                            </span>
                        </td>
                        <td>{{ individualKhasra?.area }}</td>
                        <td>{{commonService.formatIndianCurrency(individualKhasra?.paymentToCurrentFarmer)}}</td>
                        <td>{{commonService.formatIndianCurrency(individualKhasra?.paidAmount)}}</td>
                    </tr>
                    <tr>
                        <td class="submissionData font-weight-bolder">Total</td>
                        <td class="submissionData">{{khata?.totalArea}}</td>
                        <td class="submissionData"></td>
                        <td class="submissionData"></td>
                    </tr>
                </table>
            </div>

            <div class="formSection" *ngIf="currentClientData?.bankKhata?.length > 0">
                <div class="head">
                    <strong>Bank Khata Info</strong>
                </div>
            </div>
        </ng-container>
    </div>
</div>